import getCollectionQuery from "../../utils/getCollectionQuery";

export default function getArticlesQuery(firebase, options) {
	if (!options) {
		return null;
	}

	const { publisher, production, imprint, serie, work, type, limit } = options;

	return getCollectionQuery(firebase.firestore().collection("articles"), {
		fields: {
			publisher,
			production,
			imprint,
			serie,
			work,
			type,
		},
		limit,
		orderBy: ["name", "asc"],
		softDeletes: true,
	});
}
